import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Client, PaginatedClientList } from "../../app/generated-axios-client";

export interface ClientState {
  client: Client | null;
  list: PaginatedClientList;
}

const initialState: ClientState = {
  client: null,
  list: {
    "pagination": {
      "total_items": 0,
      "total_pages": 0,
      "current_page": 0,
      "per_page": 0,
    },
    "results": [],
  },
};

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    addOrUpdateClient: (state, action: PayloadAction<Client>) => {
      state.client = action.payload;
    },
    storeClient: (state, action: PayloadAction<Client>) => {
      state.client = action.payload;
    },
    removeClient: (state) => {
      state.client = null;
    },
    deleteClient: (_state, _action: PayloadAction<string>) => {},
    addClientList: (state, action: PayloadAction<PaginatedClientList>) => {
      state.list = action.payload;
    },
  },
});

export const clientActions = clientSlice.actions;
export default clientSlice.reducer;
